import CgPopover from './CgPopover';
import 'flag-icons/css/flag-icons.min.css';

export function TableCountry(props) {
  return (
    <CgPopover
      key={'overlayDelete' + props.index}
      trigger="click"
      position="top"
      popoverContent={props.nameOut ? props.iso3 : props.name}
      triggerElement={
        <td className="align-middle">
          <span className={`fi fi-${props.iso2?.toLowerCase()}`}></span>
          {` ${props.nameOut ? props.name : props.iso3}` ?? '-'}
        </td>
      }
    />
  );
}
